import type { FC } from 'react';

import Text from '@/components/Text';
import { cn } from '@/lib/utils';

import Chip from '../Chip';

type Props = {
  chips: string[];
};

const SeniorityLevelChips: FC<Props> = ({ chips }) => (
  <div className="flex flex-wrap gap-2">
    {chips.map((chipValue) => (
      <Chip
        variant="rounded-light-gray"
        key={chipValue}
        size="sm-long"
        className={cn({
          '!border-jb-neutral-500 !bg-jb-neutral-300 !text-jb-neutral-700':
            chipValue === 'Intern',
          '!border-jb-success-400 !bg-jb-success-100 !text-jb-success-600':
            chipValue === 'Junior',
          '!border-secondary-300 !bg-secondary-100 !text-secondary-700':
            chipValue === 'Mid',
          '!border-jb-primary-400 !bg-jb-primary-100 !text-jb-primary-500':
            chipValue === 'Senior',
        })}
      >
        <Text variant="jb-body-medium">{chipValue}</Text>
      </Chip>
    ))}
  </div>
);

export default SeniorityLevelChips;
